// src/components/Footer.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 2,
      mt: "auto",            // レイアウトが flex の場合に下部に固定
      textAlign: "center",
      bgcolor: "background.paper",
    }}
  >
    <Typography variant="body1" color="text.secondary">
      ©2025 Nakamura_Lab
    </Typography>
  </Box>
);

export default Footer;
